export const RECIPE_SERVINGS_DATA = {
  min: 1,
  max: 1000,
  step: 1
};
